import { ApiClientFactory } from "common/middleware/api.client-factory";
import { AcceptRequestOpportunityChatCommand } from "common/middleware/api.services";

export const acceptRequestToChat = async (opportunityId: string) => {
  const client = await ApiClientFactory.getSharedOpportunitiesClient();
  await client.acceptRequestToChat(opportunityId, new AcceptRequestOpportunityChatCommand());
}
